import { useState, useEffect } from 'react';
import './MonthlyPaperPicker.css';
import { useLang } from '../context/LanguageContext';

import { API_URL as API } from '../config/env.js';

function toMonthKey(year, monthIndex) {
  return `${year}-${String(monthIndex + 1).padStart(2, '0')}`;
}

export default function MonthlyPaperPicker({ onSelectMonth, onClose }) {
  const { t } = useLang();
  const today = new Date();
  const [viewYear, setViewYear] = useState(today.getFullYear());
  const [availableMonths, setAvailableMonths] = useState(new Set());

  useEffect(() => {
    fetch(`${API}/api/monthly-papers`)
      .then((r) => r.json())
      .then((d) => setAvailableMonths(new Set(d.months || [])))
      .catch(() => {});
  }, []);

  const currentMonthKey = toMonthKey(today.getFullYear(), today.getMonth());
  const recentMonths = [...availableMonths].sort().reverse().slice(0, 4);

  const formatMonth = (monthKey) => {
    const [y, m] = monthKey.split('-');
    return `${t.months[parseInt(m, 10) - 1]} ${y}`;
  };

  const canGoNextYear = viewYear < today.getFullYear();

  return (
    <div className="mcal-backdrop" onClick={onClose}>
      <div className="mcal-shell" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="mcal-x" onClick={onClose} aria-label={t.closeBtn}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" aria-hidden>
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h2 className="mcal-title">{t.monthlyEdition || 'నెలవారీ మ్యాగజైన్'}</h2>
        <p className="mcal-sub">{t.monthlyCalSub}</p>

        <div className="mcal-year-nav">
          <button type="button" className="mcal-year-btn" onClick={() => setViewYear((y) => y - 1)} aria-label="Previous year">
            ‹
          </button>
          <span>{viewYear}</span>
          <button
            type="button"
            className="mcal-year-btn"
            onClick={() => setViewYear((y) => y + 1)}
            disabled={!canGoNextYear}
            aria-label="Next year"
          >
            ›
          </button>
        </div>

        <div className="mcal-grid">
          {t.months.map((name, idx) => {
            const key = toMonthKey(viewYear, idx);
            const isFuture =
              viewYear > today.getFullYear() ||
              (viewYear === today.getFullYear() && idx > today.getMonth());
            const hasPaper = availableMonths.has(key);
            const disabled = !hasPaper || isFuture;

            return (
              <button
                key={key}
                type="button"
                className={`mcal-month${hasPaper ? ' has-paper' : ''}${key === currentMonthKey ? ' is-current' : ''}`}
                disabled={disabled}
                onClick={() => onSelectMonth(key)}
              >
                <span className="mcal-month-name">{name}</span>
                {hasPaper && <span className="mcal-month-dot" aria-hidden />}
              </button>
            );
          })}
        </div>

        {recentMonths.length > 0 && (
          <div className="mcal-recent">
            <span className="mcal-recent-label">{t.calRecent}</span>
            <div className="mcal-recent-list">
              {recentMonths.map((mk) => (
                <button key={mk} type="button" className="mcal-recent-btn" onClick={() => onSelectMonth(mk)}>
                  {formatMonth(mk)}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
